const haversineDistance = (lat1: number, lon1: number, lat2: number, lon2: number) => {
  const toRadians = (degrees: number) => degrees * (Math.PI / 180);

  const R = 6371; // Radius of the Earth in kilometers
  const dLat = toRadians(lat2 - lat1);
  const dLon = toRadians(lon2 - lon1);
  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c; // Distance in kilometers

  return distance;
};

//maxDistance: number =  0.002 km (2 meters)
export const arePointsClose = (lat1: number, lon1: number, lat2: number, lon2: number, maxDistance = 0.002) => {
  try {
    const distance = haversineDistance(lat1, lon1, lat2, lon2);
    return distance <= maxDistance;
  } catch (err) {
    return false;
  }
};
